import { FeatureAnchor, SampleAnchor, SampleQuote } from "../PaperShared/Sample";

function Sample393485() {
  return (
    <section className="sample">
      <h4>
        <SampleAnchor modelId="baby-v1" sampleId="393485" />
        <span> - </span>
        <SampleQuote text="of his fair" targetIdx={7} />
      </h4>
      <p>
        Feature <FeatureAnchor modelId="baby-v1" sampleId="393485" featureKey="0.5.4138" compact />{" "}
        predicts the formation of nouns and noun phrases beginning with an “f” by building upon
        upstream features that detect possessives and definite articles. Feature{" "}
        <FeatureAnchor modelId="baby-v1" sampleId="301857" featureKey="0.1.217" compact /> fires
        just after “our” and “your”. Feature{" "}
        <FeatureAnchor modelId="baby-v1" sampleId="300553" featureKey="1.2.1998" compact /> fires on
        the space after “thy” and “the”. Feature{" "}
        <FeatureAnchor modelId="baby-v1" sampleId="393485" featureKey="1.1.1349" compact /> fires on
        the space after “this” and “his”. Information from these features flow downstream through
        other intermediary features like feature{" "}
        <FeatureAnchor modelId="baby-v1" sampleId="393485" featureKey="0.5.4138" compact /> to
        enable sharper LLM predictions.
      </p>
      <figure>
        <figcaption>Circuit Detecting Nouns and Noun Phrases</figcaption>
        <ul className="tree">
          <li>
            <span className="node">
              <span className="feature">
                <FeatureAnchor
                  modelId="baby-v1"
                  sampleId="393485"
                  featureKey="0.5.4138"
                  compact={true}
                />
              </span>
              <span className="description">
                <SampleQuote text="our father" targetIdx={4} quotes={false} ellipsis={false} />
                <SampleQuote text="thy fortune" targetIdx={4} quotes={false} ellipsis={false} />
                <SampleQuote
                  text="his fair demands"
                  targetIdx={4}
                  quotes={false}
                  ellipsis={false}
                />
              </span>
            </span>
            <ul>
              <li>
                <span className="node">
                  <span className="feature">
                    <FeatureAnchor
                      modelId="baby-v1"
                      sampleId="393485"
                      featureKey="0.4.3553"
                      compact={true}
                    />
                  </span>
                  <span className="description">
                    <SampleQuote text="your office" targetIdx={7} quotes={false} ellipsis={false} />
                    <SampleQuote text="thy affair" targetIdx={5} quotes={false} ellipsis={false} />
                  </span>
                </span>
                <ul>
                  <li>
                    <span className="node">
                      <span className="feature">
                        <FeatureAnchor
                          modelId="baby-v1"
                          sampleId="301857"
                          featureKey="0.1.217"
                          compact={true}
                        />
                      </span>
                      <span className="description">
                        <SampleQuote text="our ⎵" targetIdx={4} quotes={false} ellipsis={false} />
                        <SampleQuote text="your ⎵" targetIdx={5} quotes={false} ellipsis={false} />
                      </span>
                    </span>
                  </li>
                  <li>
                    <span className="node">
                      <span className="feature">
                        <FeatureAnchor
                          modelId="baby-v1"
                          sampleId="300553"
                          featureKey="1.2.1998"
                          compact={true}
                        />
                      </span>
                      <span className="description">
                        <SampleQuote text="the " targetIdx={3} quotes={false} ellipsis={false} />
                        <SampleQuote text="thy " targetIdx={3} quotes={false} ellipsis={false} />
                      </span>
                    </span>
                  </li>
                </ul>
              </li>
              <li>
                <span className="node">
                  <span className="feature">
                    <FeatureAnchor
                      modelId="baby-v1"
                      sampleId="393485"
                      featureKey="0.4.1362"
                      compact={true}
                    />
                  </span>
                  <span className="description">
                    <SampleQuote text="his death" targetIdx={4} quotes={false} ellipsis={false} />
                  </span>
                </span>
                <ul>
                  <li>
                    <span className="node">
                      <span className="feature">
                        <FeatureAnchor
                          modelId="baby-v1"
                          sampleId="393485"
                          featureKey="1.1.1349"
                          compact={true}
                        />
                      </span>
                      <span className="description">
                        <SampleQuote text="his " targetIdx={3} quotes={false} ellipsis={false} />
                        <SampleQuote text="this " targetIdx={4} quotes={false} ellipsis={false} />
                      </span>
                    </span>
                  </li>
                </ul>
              </li>
              <li>
                <span className="node">
                  <span className="feature">
                    <FeatureAnchor
                      modelId="baby-v1"
                      sampleId="393485"
                      featureKey="0.4.5062"
                      compact={true}
                    />
                  </span>
                  <span className="description">
                    <SampleQuote text="and from" targetIdx={4} quotes={false} ellipsis={false} />
                  </span>
                </span>
                <ul>
                  <li>
                    <span className="node">
                      <span className="feature">
                        <FeatureAnchor
                          modelId="baby-v1"
                          sampleId="393485"
                          featureKey="1.0.2693"
                          compact={true}
                        />
                      </span>
                      <span className="description">
                        <SampleQuote text=" " targetIdx={0} quotes={false} ellipsis={false} />
                      </span>
                    </span>
                  </li>
                  <li>
                    <span className="node">
                      <span className="feature">
                        <FeatureAnchor
                          modelId="baby-v1"
                          sampleId="393485"
                          featureKey="0.0.5588"
                          compact={true}
                        />
                      </span>
                      <span className="description">
                        <SampleQuote text="f" targetIdx={0} quotes={false} ellipsis={false} />
                      </span>
                    </span>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </figure>
    </section>
  );
}

export { Sample393485 };
